
export default {
  // Common
  "language": "Sprache",
  "language_description": "Ändern Sie die in der gesamten Anwendung verwendete Sprache",
  "save_language": "Spracheinstellung speichern",
  "updating": "Aktualisierung...",
  "return_home": "Zurück zur Startseite",
  "sign_out": "Abmelden",
  "error": "Fehler",
  "loading": "Wird geladen...",
  "cancel": "Abbrechen",
  "save": "Speichern",
  "edit": "Bearbeiten",
  "delete": "Löschen",
  "back": "Zurück",
  "view_details": "Details anzeigen",
  "not_applicable": "N/A",
  "invalid_date": "Ungültiges Datum",
  "name": "Name",
  "qty": "Anz.",
  "actions": "Aktionen",
  "sort_by": "Sortieren nach",
  "filter_by": "Filtern nach",
  "ascending": "Aufsteigend",
  "descending": "Absteigend",
  "date_added": "Hinzugefügt am",
  "retry": "Erneut versuchen",
  "with": "mit",
  "or": "oder",
  "format": "Format",
  "username": "Benutzername",
  "phone_number": "Telefonnummer",
  "email": "E-Mail",
  "change": "Ändern",
  "save_changes": "Änderungen speichern",
};
